export default __webpack_public_path__ + "static/media/ic_previous_claim.18e59f63.svg";